<template>
  <a-spin :spinning="isLoading">

    <ls-table-layout>
      <div class="table-page-search-wrapper" slot="search">
        <div class="subtitle-text">MPS选项</div>
        <a-form layout="inline" :labelCol="{ style: { width: '95px' } }">
          <a-row>
            <a-col :md="8" :sm="24">
              <a-form-item label="分配集名称">
                <global-select
                  :value.sync="commitData.assignmentSetId"
                  selectType="selectSearch"
                  requestApi="/scp/scpSopMpsOptions/listAssignmentSet"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="version"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="延迟满足天数">
                <a-input-number id="inputNumber" v-model="commitData.delaySatisfyDays" :min="1" />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="计划展望期M+">
                <a-input-number id="inputNumber" v-model="commitData.planningHorizonDays" :min="1" />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="订单自动延后">
                <a-select show-search option-filter-prop="children" v-model="commitData.autoDelayOrder" allowClear>
                  <a-select-option v-for="(item) in baseUomFlagOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="计划时段">
                <div class="plan_time">
                  <a-input-number class="ml10 number_width" id="inputNumber" v-model="commitData.monthlyCutoffBucket" :min="1" />
                  <span class="ml10" >月</span>
                  <a-input-number class="ml10 number_width" id="inputNumber" v-model="commitData.weeklyCutoffBucket" :min="1" />
                  <span class="ml10" >周</span>
                  <a-input-number class="number_width" id="inputNumber" v-model="commitData.dailyCutoffBucket" :min="1" />
                  <span class="ml10" >天</span>
                </div>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="一件代发">
                <global-select
                  :value.sync="commitData.singleShipment"
                  :allowClear="false"
                  :selectData="singleShipmentOption"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="24">
              <a-form-item label="产品属性">
                <!-- <a-select show-search option-filter-prop="children" v-model="commitData.itemAttribute" allowClear>
                  <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
                </a-select> -->
                <global-select
                  @change="commitData.includeValues=undefined"
                  :value.sync="commitData.itemAttribute"
                  selectType="selectFilter"
                  :selectData="uomClassOptions"
                  :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="包含值">
                <!-- <a-select show-search mode="multiple" option-filter-prop="children" v-model="commitData.includeValues" allowClear>
                  <a-select-option v-for="(item) in includeValueOptions" :key="item.lookupType">{{ item.lookupCode }}</a-select-option>
                </a-select> -->
                <global-select
                  :setParams="{category:commitData.itemAttribute}"
                  :value.sync="commitData.includeValues"
                  selectType="selectMultiple"
                  requestApi="/scp/scpSopMpsOptions/listIncluding"
                  :selectItem="{ value: 'realValue', label: 'label' }"
                  searchParam="version"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="table-page-operator-wrapper" slot="btn">
        <a-button @click="handleSaveComfirm" type="primary">保存</a-button>
        <a-button @click="addLine" type="primary">新增行</a-button>
      <!-- <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomConversions:export']">导出</a-button> -->
      </div>
      <template v-slot:table>
        <div class="page-header-content">
          <div class="subtitle-text">排产锁定期</div>
          <ls-api-table
            ref="dataTable"
            :columns="columns"
            :tableProps="tableProps"
            rowKey="id"
            :scroll="{ fixScreen: true, x: 1300 }"
            :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.MPS_OPTION_LIST, // 表格方案配置唯一值
              }"
          >

            <template slot="insideOutside" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.indexId">{{ insideOutsideValue(record) }}</span>
              <a-select size="small" class="a-select-width" v-if="isEdit && currentId === record.indexId" show-search option-filter-prop="children" v-model="record.insideOutside" allowClear>
                <a-select-option v-for="(item) in SCP_SUPPLIER_CATEGORY " :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </template>
            <template slot="number" slot-scope="{ record, column }">
              <span v-if="!isEdit || currentId !== record.indexId">{{ record[column.dataIndex] }}</span>
              <a-input-number
                v-if="isEdit && currentId === record.indexId"
                v-model="record[column.dataIndex]"
                size="small"
              />
              <!-- <a-button @click="handlerTestClick(record, column)"> 测试</a-button>  @change="handleInputChange(record,column.dataIndex)"-->
            </template>
            <template slot="checkBox" slot-scope="{ record, column }">
              <a-switch :disabled="!isEdit || currentId !== record.indexId" :checked="record[column.dataIndex] === 'Y'" @change="statusOnChange(record,column.dataIndex)" />
            </template>
            <template slot="orderType" slot-scope="{ record }">
              <span v-if="!isEdit || currentId !== record.indexId">{{ record.orderType }}</span>
              <a-select size="small" class="a-select-width" v-if="isEdit && currentId === record.indexId" show-search option-filter-prop="children" v-model="record.orderType" allowClear>
                <a-select-option v-for="(item) in SCP_MRP_SUPPLY_TYPE " :key="item.lookupValue">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </template>
            <template slot="updateTime" slot-scope="{ text }">
              <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
            </template>
            <template slot="createTime" slot-scope="{ text }">
              <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
            </template>
            <template slot="status" slot-scope="{ record }">
              <a-switch :disabled="!isEdit || currentId !== record.indexId" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
            </template>
            <!-- 操作 -->
            <span slot="operation" slot-scope="{ record }">
              <a v-if="!isEdit || currentId !== record.indexId" @click="handleEdit(record)">编辑</a>
              <a v-if="!isEdit || currentId !== record.indexId" class="ml10" @click="handleDelete(commitData.listLockedRules, record)">删除</a>
              <!-- <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a> -->
              <a v-if="isEdit && currentId === record.indexId" @click="handleCancel(record)" class="ml10">确定</a>
            </span>
          </ls-api-table>
        </div>
      </template>
    </ls-table-layout>
  </a-spin>
</template>

<script>
import { generateLsTableResData } from '@/utils/util.js';
import { apiScpSopMpsOptionsList, apiSaveMpsOptions } from '@/api/mps/basic-data/mps-option.js';

export default {
  // eslint-disable-next-line
  name: 'Mps-option',
  components: {
  },
  data () {
    return {
      isLoading: false,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiScpSopMpsOptionsList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      commitData: {
        assignmentSetId: '',
        delaySatisfyDays: 0,
        planningHorizonDays: 0,
        autoDelayOrder: '',
        dailyCutoffBucket: '',
        weeklyCutoffBucket: '',
        monthlyCutoffBucket: '',
        itemAttribute: '',
        includeValues: '',
        listLockedRules: []
      },
      // 查询参数
      queryParams: {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 表格字段
      columns: [
        {
          title: '内外部',
          dataIndex: 'insideOutside',
          scopedSlots: { customRender: 'insideOutside' },
          align: 'center',
          width: 160
        },
        {
          title: '天数起',
          dataIndex: 'dayFrom',
          scopedSlots: { customRender: 'number' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '天数止',
          dataIndex: 'dayTo',
          width: 120,
          scopedSlots: { customRender: 'number' },
          align: 'center'
        },
        {
          title: '新增',
          dataIndex: 'ifAdd',
          scopedSlots: { customRender: 'checkBox' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '取消',
          dataIndex: 'cancel',
          scopedSlots: { customRender: 'checkBox' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '提前',
          dataIndex: 'rescheduledIn',
          scopedSlots: { customRender: 'checkBox' },
          align: 'center'
        },
        {
          title: '延后',
          dataIndex: 'rescheduledOut',
          scopedSlots: { customRender: 'checkBox' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '允许提前天数',
          dataIndex: 'allowedDays',
          scopedSlots: { customRender: 'number' },
          width: 150,
          align: 'center'
        },
        {
          title: '发放单据类型',
          dataIndex: 'orderType',
          width: 160,
          scopedSlots: { customRender: 'orderType' },
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      singleShipmentOption: [
        { lookupValue: '全部', lookupCode: 'A' },
        { lookupValue: '是', lookupCode: 'Y' },
        { lookupValue: '否', lookupCode: 'N' }
      ], // 一件代发
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [], // 基本单位
      includeValueOptions: []
    }
  },
  computed: {
    insideOutsideValue() {
      return function(record) {
        if (this.SCP_SUPPLIER_CATEGORY && this.SCP_SUPPLIER_CATEGORY.find(item => item.lookupCode === record.insideOutside)) {
          return this.SCP_SUPPLIER_CATEGORY.find(item => item.lookupCode === record.insideOutside).lookupValue
        }
        return record.insideOutside;
      }
    }
  },
  created () {
    const lookupQueryParams = {
      lookupType: 'SCP_ITEM_ATTRIBUTE',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryParams).then(response => {
      this.uomClassOptions = response.rows
    })

    const lookupQueryIncludeParams = {
      lookupType: 'SCP_PRODUCT_BROAD_CATEGORY',
      current: 1,
      pageSize: 100
    }
    this.getLookupListData(lookupQueryIncludeParams).then(response => {
      this.includeValueOptions = response.rows
    })
    this.getLookupList('SCP_SUPPLIER_CATEGORY')
    this.getLookupList('SCP_MRP_SUPPLY_TYPE', { attribute2: 'Y' })
  },
  mounted () {
    this.loadPageData()
  },
  methods: {
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    getLookupList (type, ohterParams) {
      this[type] = [];
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100,
        ...ohterParams
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        if (response.rows) {
          response.rows.forEach((item) => {
            this[type].push(item);
          })
        }
      })
   },
    loadPageData () {
      this.Loading = true
      apiScpSopMpsOptionsList().then(response => {
        this.Loading = false
        if (response.code === 200) {
          this.commitData = { ...response.data }
          // 如果一件代发没有值，默认给“否”
          if(!this.commitData?.singleShipment) { this.commitData.singleShipment = 'N' }
          this.commitData.listLockedRules = response.data.listLockedRules
          this.commitData.listLockedRules = this.commitData.listLockedRules.map(item => ({
            ...item,
            indexId: Date.now().toString(36) + Math.random().toString(36).substr(2, 5)
          }));
          this.isEdit = false;
          this.$refs.dataTable.myDataSource = this.commitData.listLockedRules
        } else {
          this.$message.error(response.msg)
        }
      }).catch(function () {
        this.Loading = false
      })
    },
        // 新增行
    addLine () {
      if (!this.commitData.listLockedRules) {
        this.commitData.listLockedRules = []
      }
      const arr = JSON.parse(JSON.stringify(this.commitData.listLockedRules))
      // const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
      const obj = {
        allowedDays: 0,
        cancel: '',
        dayFrom: 0,
        dayTo: 0,
        deleted: 0,
        ifAdd: '',
        insideOutside: '',
        orderType: '',
        rescheduledIn: '',
        rescheduledOut: '',
        // indexId: Number(indexId) + 1
        indexId: Date.now().toString(36) + Math.random().toString(36).substr(2, 5)

      }
      arr.push(obj)
      this.commitData.listLockedRules = arr
      this.$refs.dataTable.myDataSource = this.commitData.listLockedRules
    },
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record, column) {
      record[column] = record[column] === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.download('mdm/mdmUomConversions/export', {
        ...this.queryParams
      }, `标准单位转换_${new Date().getTime()}.xlsx`)
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.indexId !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.indexId;
    },
    handleSaveComfirm () {
      const self = this
      this.$confirm({
        title: '提示',
        content: '你确定保存该记录吗？',
        okText: '确定',
        okType: 'danger',
        cancelText: '取消',
        onOk () {
          self.handleSave()
        },
        onCancel () {
        }
      });
    },
    // 编辑-保存
    handleSave (record) {
      // if (!record.conversionRate || Number(record.conversionRate) <= 0) {
      //   this.$message.warning('折换不能为空且需大于0')
      //   return
      // }
      apiSaveMpsOptions(this.commitData).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
     // this.onSearch()
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}.plan_time{
  display: flex;
}.number_width{
  width: 60px;
}.a-select-width{
  width: 130px;
}
.subtitle-text {
  font-size: 16px;
  font-weight: bolder;
}
</style>
